export function UpgradeGate({ onClose }: { onClose?: () => void }) {
  return (
    <div className="upgrade-gate-overlay" onClick={onClose}>
      <div className="upgrade-gate__modal" onClick={e => e.stopPropagation()}>
        {onClose && (
          <button className="upgrade-gate__close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        )}
        <div className="upgrade-gate__card">
          <h3 className="upgrade-gate__title">Unlock Production Agents</h3>
          <p className="upgrade-gate__desc">
            Get your first automation built for you. Runs durably. Human-in-the-loop. Auditable.
          </p>
          <div className="upgrade-gate__buttons">
            <a
              href="https://gumroad.com/l/yinmj"
              data-gumroad-action="buy"
              data-gumroad-recurrence="monthly"
              className="upgrade-gate__btn upgrade-gate__btn--primary"
            >
              Keep-It-Running Plan <span className="upgrade-gate__price">$49/mo</span>
            </a>
          </div>
          <p className="upgrade-gate__note">
            Opens Gumroad overlay — you never leave this page.
          </p>
        </div>
      </div>
    </div>
  );
}